import React from 'react';
import { useIntl } from '@kamernet/core/Intl';
import { PageLayout } from '@kamernet/core/PageLayout';
import { Typography } from '@mui/material';
import { CommonStyles } from '@kamernet/styles/CommonStyles';
import classnames from 'classnames';
import styles from './RentingOutOnKamernet.module.css';

export const RentingOutOnKamernet = () => {
  const { T } = useIntl();

  return (
    <PageLayout.SectionContainer>
      <Typography
        className={classnames(
          CommonStyles.padding_top_5,
          CommonStyles.padding_bottom_5,
        )}
        variant="h2"
      >
        {T('LBL_SUPPLY_HOMEPAGE_H2_ROOM_NETHERLANDS')}
      </Typography>
      <Typography
        className={styles.text}
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: T('LBL_SUPPLY_HOMEPAGE_PAGECONTENT_ROOM_NETHERLANDS'),
        }}
      />
    </PageLayout.SectionContainer>
  );
};
